import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import createDateForBackEnd from '@/employee/omApplications/common/omApplicationTools';
//import * as files from '../../fileUtils';

export default {
  name: 'Supports',
  components: {
    SupportComp: require('./support.vue').default,
  },
  mixins: [createDateForBackEnd],
  props: ['dataObj'],
  data: function () {
    return {
      jobcardData: {
        id: -1,
        originType: '-1',
        originId: -1,
        stationId: -1,
        startDateTime: new Date(),
        dateFromHH: '00',
        dateFromMin: '00',
        endDateTime: new Date(),
        actualDuration: 0,
        actualTravelDuration: 0,
        address: '',
        mActivityId: -1,
        elementTypeId: -1,
        elementId: -1,
        conditionId: -1,
        conditionComment: '',
        complainTypeId: -1,
        outcomeId: -1,
        comment: '',
        workflowEmployeeId: -1,
        dataChildren: undefined
      },
      bShowRates: false,
      sourceId: -1,
      employeeUsage: 1,
      workDuration: 0,
      travelDuration: 0,
      usageSourceTypes: [],
      supportServiceTypes: [],
      supports: [],
      availableSupports: [],
      stations: [],
      editingSupport: {},
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      showSupport: false,
      totalRow: 0,
      bInitialized: false,
      bPageChange: true,
    }
  },
  computed: {
    startDateTime: function () {
      return this.jobcardData.startDateTime ? this.jobcardData.startDateTime: this.jobcardData.dateTimeFrom;
    },
    endDateTime: function () {
      return this.jobcardData.endDateTime ? this.jobcardData.endDateTime : this.jobcardData.dateTimeTo;
    },
    dateFromHH: function () {
      return this.jobcardData.dateFromHH;
    },
    dateFromMin: function () {
      return this.jobcardData.dateFromMin;
    },
    actualDuration: function () {
      return this.jobcardData.actualDuration;
    },
    actualTravelDuration: function () {
      return this.jobcardData.actualTravelDuration;
    },
  },
  created() {
    this.getSettingsOm();
    this.getSupportLookups();
    this.getAvailableSupports();
    this.getOmUseHoursForDuration();
    this.init();
    //this.$root.$on('investigation_or_jobcard_updated', this.init);
  },
  methods: {
    getSettingsOm() {
      axios.post('/Om/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bShowRates = response.data.value.isShowManpowerAndSupportServicesRates;
          }
        });
    },
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      if (this.bPageChange === true)
        this.bPageChange = false
      else
        this.getSupports();
    },
    getServiceText(iKey) {
      return (this.supportServiceTypes.filter(t => t.id == iKey).length > 0) ? this.supportServiceTypes.filter(t => t.id == iKey)[0].name : '';
    },
    init() {
      Vue.nextTick(() => {
        this.bInitialized = false;
        this.jobcardData = this.dataObj;
        this.sourceId = this.dataObj.dataChildren ? this.dataObj.dataChildren.sourceId : this.sourceId;
        this.stationId = this.dataObj.dataChildren ? this.dataObj.dataChildren.stationId : this.stationId;
        this.employeeUsage = this.dataObj.dataChildren ? this.dataObj.dataChildren.empUsage : this.employeeUsage;
        this.workDuration = this.dataObj.dataChildren ? this.dataObj.actualDuration : this.workDuration;
        this.travelDuration = this.dataObj.dataChildren ? this.dataObj.actualTravelDuration : this.travelDuration;
        if (this.sourceId > -1)
          this.getSupports();
      });
    },
    getServiceName: function (srvId, srvType) {
      var sName = '';
      if (this.availableSupports.filter(p => p.supportServiceType == srvType && p.supportServiceId == srvId).length > 0)
        sName = this.availableSupports.filter(p => p.supportServiceType == srvType && p.supportServiceId == srvId)[0].name
      return sName;
    },
    getOmUseHoursForDuration() {
      axios.post('/Utility/GetOmUseHoursForDuration')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bHoursForDuration = response.data.value;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getOmUseHoursForDuration');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getSupportLookups() {
      axios.post('/Om/GetSupportLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.usageSourceTypes = response.data.usageSourceTypes;
            this.supportServiceTypes = response.data.supportServiceTypes;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getSupportLookups');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getSupports() {
      this.bInitialized = false;
      var parameters = { SourceType: this.employeeUsage, SourceId: this.sourceId };
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetSupportServicesAllocations', parameters),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            this.supports = response.data.items;
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
            this.bInitialized = this.jobcardData.id > 0;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Support Services'
      );
    },
    getAvailableSupports() {
      var parameters = { StationId: -1, TeamId: -1, Filter: '', SupportServiceType: 0 };
      axios.post('/Om/GetAvailableSupportServices', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.availableSupports = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getAvailableSupports');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    add() {
      this.editingSupport = {
        allocationId: -1,
        hasLogReading: false,
        logName: null,
        logValue: 0,
        sourceType: this.employeeUsage,
        supportServiceType: 1,
        sourceId: this.sourceId,
        scheduledDateTime: this.startDateTime,
        scheduledTimeHH: this.jobcardData.dateFromHH,
        scheduledTimeMin: this.jobcardData.dateFromMin,
        startDateTime: this.startDateTime,
        endDateTime: this.endDateTime,
        workDuration: this.actualDuration,
        travelDuration: this.actualTravelDuration, 
        rateType: 1,
        rateHr: 0,
        kilometrage: 0,
        readonly: false,
        rateTypes: this.rateTypes,
        stationId: this.stationId,
        bShowRateField: this.bShowRates
      };
      this.$root.$emit('support_updated');
      this.showSupport = true;
    },
    edit(support) {
      this.editingSupport = support;
      this.editingSupport.scheduledDateTime = new Date(this.editingSupport.scheduledDateTime);
      this.editingSupport.readonly = false;

      this.editingSupport.scheduledTimeHH = moment(this.editingSupport.scheduledDateTime).format('HH');
      this.editingSupport.scheduledTimeMin = moment(this.editingSupport.scheduledDateTime).format('mm');
      this.editingSupport.endDateTime = this.endDateTime;

      this.editingSupport.bShowRateField = this.bShowRates;

      this.$root.$emit('support_updated');
      this.showSupport = true;
    },
    saveSupport() {
      if (!this.editingSupport.scheduledDateTime || !this.editingSupport.scheduledTimeHH || !this.editingSupport.scheduledTimeMin) {
        this.$alertMsg(this.$t('jobcard.DateComplete'), 4);
        return;
      }

      if (!this.editingSupport.supportServiceId || this.editingSupport.supportServiceId < 0) {
        this.$alertMsg(this.$t('jobcard.AddSuppServ'), 4);
        return;
      }

      var sUrl = (this.editingSupport.allocationId == -1) ? '/Om/AddSupportServicesAllocation' : '/Om/UpdateSupportServicesAllocation';
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      let param = {
        SourceType: this.editingSupport.sourceType,
        AllocationId: this.editingSupport.allocationId,
        ScheduledDateTime: this.createDateForBackEnd(this.editingSupport.scheduledDateTime),
        ScheduledDateHours: this.editingSupport.scheduledTimeHH,
        ScheduledDateMinutes: this.editingSupport.scheduledTimeMin,
        SupportServiceType: this.editingSupport.supportServiceType,
        RateType: this.editingSupport.rateType,
      }

      if (this.editingSupport.sourceId)
        param['SourceId'] = this.editingSupport.sourceId;

      if (this.editingSupport.workDuration)
        param['WorkDuration'] = this.editingSupport.workDuration;

      if (this.editingSupport.travelDuration)
        param['TravelDuration'] = this.editingSupport.travelDuration;

      if (this.editingSupport.rateHr)
        param['RateHr'] = this.editingSupport.rateHr;

      if (this.editingSupport.supportServiceId)
        param['SupportServiceId'] = this.editingSupport.supportServiceId;

      if (this.editingSupport.logValue)
        param['LogValue'] = this.editingSupport.logValue;

      axios.post(sUrl, param)
        .then(response => {
          if (response.data.data.status == 0) {
            this.getSupports();
            this.$alertMsg(this.$t('messages.SupportSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)

          loader.hide();
          this.showSupport = false;
        })
        .catch((e) => {
          console.log('saveSupport');
          console.log(e);
          loader.hide();
          this.$alertMsg(e.message)
        })
    },
    remove(id) {
      axios.post('/Om/RemoveSupportServicesAllocations', { SourceType: this.employeeUsage, SourceId: this.sourceId, AllocationId: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.SupportDeletedSuccess'), 2);
            this.getSupports();
          }
        })
        .catch((e) => {
          console.log('remove');
          console.log(e);
          this.$alertMsg(e.message)
        })
    },
    getTimeLabel(fullDate) {
      var res = new Date(fullDate);
      return (res.getHours() < 10 ? '0' + res.getHours() : res.getHours()) + ':' + (res.getMinutes() < 10 ? '0' + res.getMinutes() : res.getMinutes());
    },
    closeDialog() {
      this.editingMessage = '';
      this.getSupports();
      this.showSupport = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getSupports();
    },
  },
  
}

